import React, { useState } from 'react';
import { FaSyncAlt } from 'react-icons/fa';

import { apiService } from '../../components/Config/api.service';
import { notify } from '../../components/Utils/Notifications';
import HeaderCard from '../../components/Header/HeaderCard';
import TableList from '../../components/Tools/TableList';
import LoadingBarWithStyles from '../../components/Utils/LoadingBarWithStyles';

// type="month" émet des valeurs partielles pendant la saisie : on ne se fie
// pas au navigateur pour interdire l'envoi, on revérifie le format ici.
const MOIS_VALIDE = /^\d{4}-\d{2}$/;

const moisCourant = () => {
    const aujourdhui = new Date();
    return `${aujourdhui.getFullYear()}-${String(aujourdhui.getMonth() + 1).padStart(2, '0')}`;
};

const COLONNES_REJETS = [
    { key: 'matricule', label: 'Matricule' },
    { key: 'employee', label: 'Employé' },
    { key: 'reason', label: 'Motif' },
];

const PayrollSync = () => {
    const [periode, setPeriode] = useState(moisCourant());
    const [enCours, setEnCours] = useState(false);
    const [rapport, setRapport] = useState(null);

    const handleLancer = async () => {
        // `disabled` ne protège ni d'un appel programmatique ni d'un second
        // clic avant le re-rendu : la garde vit aussi dans le handler.
        if (enCours || !MOIS_VALIDE.test(periode)) {
            return;
        }

        setEnCours(true);
        // Le rapport précédent ne doit pas rester lisible pendant le traitement.
        setRapport(null);

        try {
            const resultat = await apiService.syncPayroll(periode);
            setRapport(resultat);
        } catch (error) {
            notify(error?.userMessage || "La synchronisation n'a pas abouti.", '', 3);
        } finally {
            setEnCours(false);
        }
    };

    const rejets = rapport?.rejected || [];

    return (
        <div className="p-4">
            <HeaderCard
                title="Synchronisation paie"
                text="Reporte vers le pivot de paie les bulletins validés du mois choisi."
            />

            <div className="flex flex-wrap items-end gap-4 mb-6 bg-white p-6 rounded-xl shadow-md border border-gray-100">
                <div className="flex flex-col gap-1">
                    <label htmlFor="payroll-sync-month" className="text-sm font-medium">
                        Mois
                    </label>
                    <input
                        id="payroll-sync-month"
                        type="month"
                        className="px-4 py-2 border rounded-lg text-gray-700 bg-gray-50 font-medium"
                        value={periode}
                        onChange={(e) => setPeriode(e.target.value)}
                    />
                </div>

                <button
                    type="button"
                    onClick={handleLancer}
                    disabled={enCours || !MOIS_VALIDE.test(periode)}
                    className="flex items-center gap-2 px-5 py-2.5 bg-[--color-primary] hover:bg-[--bg-hover] disabled:bg-gray-300 text-white font-semibold rounded-lg transition-all shadow-md duration-200 text-sm"
                >
                    <FaSyncAlt size={16} />
                    {enCours ? 'Synchronisation en cours…' : 'Lancer la synchronisation'}
                </button>
            </div>

            {enCours && <LoadingBarWithStyles />}

            {rapport && (
                <div className="space-y-4">
                    {/* Le sélecteur de mois n'est pas verrouillé pendant la lecture du
                        rapport : l'utilisateur peut le déplacer sans relancer. Plutôt que
                        d'effacer un résultat qu'il vient de demander, on le rattache
                        explicitement à sa période pour que l'écran ne puisse jamais faire
                        passer un rapport de mars pour un résultat d'avril. */}
                    <p className="text-sm text-gray-500">
                        Résultat de la synchronisation pour {rapport.period}
                    </p>
                    <p className="font-medium">
                        {rapport.created} ligne(s) créée(s), {rapport.updated} ligne(s) mise(s) à jour.
                    </p>

                    {rejets.length > 0 && (
                        <TableList
                            columns={COLONNES_REJETS}
                            data={rejets}
                            searchDisplay={false}
                        />
                    )}
                </div>
            )}
        </div>
    );
};

export default PayrollSync;
